// extracted by mini-css-extract-plugin
export default {"container":"MainLayout_container__s5oXx","content":"MainLayout_content__nOiKO"};